import { Nature, Section } from '@mairistem/comptabilite';

class Imputation {
  articles: string[] = [];

  chapitre = '';

  nature: Nature | '' = '';

  section: Section | '' = '';
}

export default Imputation;
